// @Limitless
import { LimitlessBrand } from "../LimitlessBrand";
import { getThemeBase } from "./ThemeBase";
const typography = LimitlessBrand.typography;
const responsiveTypography = () => {
  let themeTypography = {};
  Object.keys(typography.heading).map(key => {
    const thisHeading = typography.heading[key];
    themeTypography = {
      ...themeTypography,
      [key]: {
        ...thisHeading.smallScreen,
        [getThemeBase().breakpoints.up("md")]: {
          ...thisHeading.largeScreen
        }
      }
    };
  });
  return themeTypography;
};
export const getTypography = () => {
  return {
    typography: {
      htmlFontSize: 16,
      fontFamily: "'Roboto', Helvetica, Arial, sans-serif",
      fontSize: 14,
      fontWeightLight: 400,
      fontWeightRegular: 500,
      fontWeightMedium: 700,
      lineHeight: 16,
      ...responsiveTypography(),
      ...typography.body
    }
  };
};